import React, { useState } from 'react';
import Logo from '../../image/Sequoia_logo_1.png'
import { useAuth } from '../../hooks/AuthProvider';
import { useTranslation } from 'react-i18next';

export const Login = () => {
    const { t } = useTranslation('common');
    const [input, setInput] = useState({
        username: "",
        password: ""
    })

    const auth = useAuth();
    const Login = () => {
        if (input.username === "admin" && input.password === "admin123") {
          auth.loginAction(input);
          return;
        }
        alert(t('login.invalidInput'));
      };
    return (
        <section class="bg-gray-50 dark:bg-gray-900">
            <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                <a href ="/" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
                    <img class="" src={Logo} alt="logo" />
                </a>
                <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                    <div class="bg-gray-50 p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                            {t('login.signInTitle')}
                        </h1>
                        <form class="space-y-4 md:space-y-6" action="#">
                        <div>
                            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{t('login.emailLabel')}</label>
                            <input 
                                type="email" 
                                name="email" 
                                id="email" 
                                class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                                placeholder={t('login.emailPlaceholder')} 
                                required="" 
                                onChange={(e) => setInput({...input, username: e.target.value})}
                            />
                        </div>
                        <div>
                            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{t('login.passwordLabel')}</label>
                            <input 
                                type="password" 
                                name="password" 
                                id="password" 
                                placeholder={t('login.passwordPlaceholder')} 
                                class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                                required="" 
                                onChange={(e) => setInput({...input, password: e.target.value})}
                            />
                        </div>
                        <button 
                            type="submit" 
                            class="w-full 
                                text-white 
                                bg-primary-600 
                                hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                                onClick={Login}
                        >
                            {t('login.signInButton')}
                        </button>
                        </form>
                    </div>  
                </div>
            </div>
        </section>
    )
}